module.exports = __webpack_public_path__ + "media/images/athletes/909-c41bce35869d572340b6a50b83800a6e.png";